import card1 from "../../Assets/images/notificationCard.png";
import notify2 from "../../Assets/images/notify2.png";
import notify3 from "../../Assets/images/notify3.png";
import notify4 from "../../Assets/images/notify4.png";

export const cardData = {
  cardIt: [
    {
      id: 1,
      mainImg: card1,
      ethPrice: "ETH recieved",
      ethRecieved: "0.08 eth recieved",
      days: "2 days ago",
    },
    {
      id: 2,
      mainImg: notify2,
      ethPrice: "C O I N Z",
      ethRecieved: "0.08 eth recieved",
      days: "3 days ago",
    },
    {
      id: 3,
      mainImg: notify3,
      ethPrice: "ETH recieved",
      ethRecieved: "0.08 eth recieved",
      days: "4 days ago",
    },
    {
      id: 4,
      mainImg: notify4,
      ethPrice: "ETH recieved",
      ethRecieved: "0.08 eth recieved",
      days: "8 days ago",
    },
  ],
};
